import { ImmomioButtonComponent } from '@immomio/ui/button';
import {
  computed,
  Component,
  inject,
  input,
  ChangeDetectionStrategy
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImmomioTooltipDirective } from '@immomio/ui/tooltip';

import {
  NameValue,
  PropertyApplicationStatus,
  PropertyType
} from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import {
  ImmomioRadioGroupComponent,
  type RadioItem
} from '@immomio/ui/radio-group';
import { ModalComponent } from '../modal/modal.component';
import { ModalFooterComponent } from '../modal/modal-footer/modal-footer.component';
import { InfoBoxComponent } from '../info-box/info-box.component';
import { ConfirmReasonComponent } from '../confirm-reason-modal/confirm-reason/confirm-reason.component';
import { ModalContentComponent } from '../modal/modal-content/modal-content.component';
import { ModalV2Component } from '../modal-v2/modal-v2.component';

@Component({
  selector: 'app-property-interest',
  templateUrl: './property-interest.component.html',
  styleUrls: ['./property-interest.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImmomioButtonComponent,
    ModalV2Component,
    ModalContentComponent,
    ConfirmReasonComponent,
    InfoBoxComponent,
    ImmomioRadioGroupComponent,
    FormsModule,
    ModalFooterComponent,
    ImmomioTooltipDirective,
    ModalComponent,
    TranslatePipe
  ]
})
export class PropertyInterestComponent {
  private ngbActiveModal = inject(NgbActiveModal);

  readonly propertyName = input<string>(undefined);
  readonly intent = input<string>(undefined);
  readonly fromEmail = input<boolean>(undefined);
  readonly profileComplete = input<boolean>(undefined);
  readonly reasons = input<NameValue[]>(undefined);
  readonly editProfile = input<() => void>(undefined);
  readonly isOfflineUser = input<boolean>(undefined);
  readonly propertyType = input<PropertyType>(undefined);
  readonly showV2 = input(true);
  readonly askForViewingAppointmentAttendance = input<boolean>(undefined);

  protected readonly appointmentCheckItems: RadioItem[] = [
    {
      label: 'application.interested_modal.appointment_check_yes_l',
      value: 'YES'
    },
    {
      label: 'application.interested_modal.appointment_check_no_l',
      value: 'NO'
    }
  ];
  protected readonly propertyTypeAppointmentCheckItems = computed<RadioItem[]>(
    () => {
      const type = this.propertyType()?.toLowerCase();
      return [
        {
          label: `application.interested_modal.appointment_${type}_check_yes_l`,
          value: 'YES'
        },
        {
          label: `application.interested_modal.appointment_${type}_check_no_l`,
          value: 'NO'
        }
      ];
    }
  );

  public hasVisitedViewingAppointment: string;
  public reasonTypeModel: string;
  public otherReasonText: string;
  public applicationStates = PropertyApplicationStatus;

  public get isInterested() {
    return this.intent() === PropertyApplicationStatus.INTENT;
  }

  close() {
    this.ngbActiveModal.close();
  }

  public onEditProfile() {
    this.ngbActiveModal.dismiss(true);
    return this.editProfile()();
  }

  public cancel() {
    this.ngbActiveModal.dismiss();
  }

  public confirmIntent() {
    this.ngbActiveModal.close({
      intent: true
    });
  }

  public denyIntent() {
    this.ngbActiveModal.close({
      intent: false,
      reasonType: this.reasonTypeModel,
      otherReasonText: this.otherReasonText
    });
  }
}
